import { addIcons } from "ionicons";
import { clipboard, cloudUpload, logOut, cart, ribbon, phonePortrait, trash, eye,
  person, mail, copy, clock, people, wifi, grid, save, key, menu, add, download, 
  create, list, call, link, stats, checkmarkCircle, radioButtonOn, checkbox, barcode,
  share, calendar, time, image, pin, folderOpen, pricetag, options, checkmark, refresh,
  camera, settings, personAdd, closeCircle, logoGoogle, logoApple, logoAndroid, qrScanner
} from "ionicons/icons";
addIcons({
  "ios-add": add.ios, "md-add": add.md,
  "ios-key": key.ios, "md-key": key.md,
  "ios-pin": pin.ios, "md-pin": pin.md,
  "ios-eye": eye.ios, "md-eye": eye.md,
  "ios-time": time.ios, "md-time": time.md,
  "ios-link": link.ios, "md-link": link.md,
  "ios-call": call.ios, "md-call": call.md,
  "ios-list": list.ios, "md-list": list.md,
  "ios-menu": menu.ios, "md-menu": menu.md,
  "ios-cart": cart.ios, "md-cart": cart.md,
  "ios-copy": copy.ios, "md-copy": copy.md,
  "ios-mail": mail.ios, "md-mail": mail.md,
  "ios-wifi": wifi.ios, "md-wifi": wifi.md,
  "ios-grid": grid.ios, "md-grid": grid.md,
  "ios-save": save.ios, "md-save": save.md,
  "ios-image": image.ios, "md-image": image.md,
  "ios-stats": stats.ios, "md-stats": stats.md,
  "ios-clock": clock.ios, "md-clock": clock.md,
  "ios-trash": trash.ios, "md-trash": trash.md,
  "ios-share": share.ios, "md-share": share.md,
  "ios-camera": camera.ios, "md-camera": camera.md,
  "ios-create": create.ios, "md-create": create.md,
  "ios-ribbon": ribbon.ios, "md-ribbon": ribbon.md,
  "ios-person": person.ios, "md-person": person.md,
  "ios-people": people.ios, "md-people": people.md,
  "ios-refresh": refresh.ios, "md-refresh": refresh.md,
  "ios-scanner": qrScanner.ios, "md-scanner": qrScanner.md,
  "ios-log-out": logOut.ios, "md-log-out": logOut.md,
  "ios-options": options.ios, "md-options": options.md,
  "ios-barcode": barcode.ios, "md-barcode": barcode.md,
  "ios-pricetag": pricetag.ios, "md-pricetag": pricetag.md,
  "ios-calendar": calendar.ios, "md-calendar": calendar.md,
  "ios-checkbox": checkbox.ios, "md-checkbox": checkbox.md,
  "ios-download": download.ios, "md-download": download.md,
  "ios-settings": settings.ios, "md-settings": settings.md,
  "ios-checkmark": checkmark.ios, "md-checkmark": checkmark.md,
  "ios-clipboard": clipboard.ios, "md-clipboard": clipboard.md,
  "ios-person-add": personAdd.ios, "md-person-add": personAdd.md,
  "ios-logo-apple": logoApple, "md-logo-apple": logoApple,
  "ios-logo-google": logoGoogle, "md-logo-google": logoGoogle,
  "ios-logo-android": logoAndroid, "md-logo-android": logoAndroid,
  "ios-folder-open": folderOpen.ios, "md-folder-open": folderOpen.md,
  "ios-close-circle": closeCircle.ios, "md-close-circle": closeCircle.md,
  "ios-cloud-upload": cloudUpload.ios, "md-cloud-upload": cloudUpload.md,
  "ios-phone-portrait": phonePortrait.ios, "md-phone-portrait": phonePortrait.md,
  "ios-radio-button-on": radioButtonOn.ios, "md-radio-button-on": radioButtonOn.md,
  "ios-checkmark-circle": checkmarkCircle.ios, "md-checkmark-circle": checkmarkCircle.md
});